<template>
  <v-container fluid grid-list-md>
    <v-tabs>
      <v-tab ripple>Modèles</v-tab>
      <v-tab-item>
        <templates-table></templates-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>
<script>
import TemplatesTable from "./TemplatesTable";

export default {
  components: {
    TemplatesTable
  },
};
</script>
